/**
 * WPS Groove Services - API service layer for WPS (Welding Procedure Specification) operations
 * Handles CRUD operations for groove welding procedures, project management, and validation
 */
import axios from "axios";

// Dynamic API URL configuration based on environment
let GROOVE_API_URL;

if (process.env.REACT_APP_NODE_ENV === "local") {
  GROOVE_API_URL = process.env.REACT_APP_WPS_GROOVE_API_URL;
} else {
  GROOVE_API_URL = process.env.REACT_APP_API_URL + "wps";
}

/**
 * Get all groove WPS records by type
 * @param {string} type - WPS type (Groove/Overlay)
 * @returns {Object} API response with WPS records
 */
export async function getallgroove(type) {
  const response = await axios
    .get(GROOVE_API_URL + `/WpsHeaderMast/${type}`)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
}


/**
 * Get grid header data with filters for WPS listing
 * @param {string} type - WPS type
 * @param {string} band - Band filter
 * @param {string} user - User filter
 * @param {string} year - Year filter
 * @returns {Object} Filtered WPS grid data
 */
export async function getGridHeaderData(type, band, user, year) {
  let reqbody = { type: type, band: band, user: user, year: year }

  const response = await axios
    .post(GROOVE_API_URL + `/WpsHeaderMast/grid`, reqbody)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
}

/**
 * Get WPS records by project number with primary and secondary keys
 * @param {string} type - WPS type
 * @param {string} IdprojectPK - Project primary key
 * @param {string} IdprojectSK - Project secondary key
 * @returns {Object} WPS records for the project
 * WPS_Validations.js
 */
export const getbyprojectno = async (type, IdprojectPK, IdprojectSK) => {
  let url = `${GROOVE_API_URL}/WpsHeaderMast/getprojectno`;
  let reqbody = { Type: type, PK: IdprojectPK, SK: IdprojectSK }
  const response = await axios.post(url, reqbody)
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

/**
 * Get WPS numbers by project - Used for project-specific WPS listing
 * @param {string} type - WPS type
 * @param {string} IdprojectPK - Project primary key
 * @returns {Object} WPS numbers for the project
 * used in WCS and WCS_Validations
 */
export const getbyprojectnoWPS = async (type, IdprojectPK) => {
  let url = `${GROOVE_API_URL}/WpsHeaderMast/getProjWPSNo`;
  let reqbody = { Type: type, PK: IdprojectPK }
  const response = await axios.post(url, reqbody)
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

/**
 * Get WI (Welding Instructions) by project number
 * @param {string} type - WPS type
 * @param {string} IdprojectPK - Project primary key
 * @param {string} IdprojectSK - Project secondary key
 * @returns {Object} WI records for the project
 */
export const getWIbyProjectNo = async (type, IdprojectPK, IdprojectSK) => {
  let url = `${GROOVE_API_URL}/WpsHeaderMast/getprojectnoWI`;
  let reqbody = { Type: type, PK: IdprojectPK, SK: IdprojectSK }
  const response = await axios.post(url, reqbody)
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};

/**
 * Add new groove WPS record
 * @param {Object} WPS_Header_Master - WPS header data
 * @returns {Object} API response with created record
 */
export const AddNewGroove = async (WPS_Header_Master) => {
  let url = `${GROOVE_API_URL}/WpsHeaderMast`;
  const response = await axios
    .post(url, WPS_Header_Master)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: error.message, status: false };
    });

  return response;
};

/**
 * Delete groove WPS record
 * @param {Object} DeleteRow - Record to delete
 * @returns {Object} Deletion response
 */
export async function DeleteGroove(DeleteRow) {
  let url = `${GROOVE_API_URL}/WpsHeaderMast/delete`;
  const resp = await axios
    .post(url, DeleteRow)
    .then(function (response) {
      return response.data;
    })
    .catch(function (error) {
      return error.message;
    });

  return resp;
}

/**
 * Validate WPS number existence - Used in WPS_Validations.js checkWPSinArray function
 * @param {Object} reqData - Request data for validation containing wpsno and groovetype
 * @returns {Array} Array of found WPS records
 */
export const checkValidWPS = async (reqData) => {
  let url = `${GROOVE_API_URL}/check/getwpsno`;
  const response = await axios
    .post(url, reqData)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });

  let resArray = response.data["foundWPS"];
  return resArray;
};


export const checkProjectWPS = async (body) => {
  let url = `${GROOVE_API_URL}/WpsHeaderMast/check-project-wps`;
  const response = await axios.post(url, body)
    .then(function (resp) {
      return resp;
    })
    .catch(function (error) {
      return { message: "Unable to find request", status: false };
    });
  return response.data;
};